module.exports = __webpack_public_path__ + "img/circle.5cd3d5cf.png";